// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1EfRL","col":"styles_col__3q3Fw"};